/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import apiService from 'src/enviroment';
import { loaderService } from './loaderService';

const getFiltersParts = async () => {
  loaderService.show();

  try {
    const { data, status } = await apiService.get(
      '/repuestos/calculos_grafica_proyeccion/',
    );
    if (status === 200) {
      console.log(data)
      return data;
    }
    return false;
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const graphOnDemand = async (body) => {
  loaderService.show();

  try {
    const { data, status } = await apiService.post(
      '/repuestos/calculos_grafica_demanda/',
      body,
    );
    if (status === 200) {
      return data;
    }
    return false;
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const graphOnProyection = async (body) => {
  loaderService.show();

  try {
    const { data, status } = await apiService.post(
      '/repuestos/calculos_grafica_proyeccion/',
      body,
    );
    if (status === 200) {
      return data;
    }
    return false;
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const graphApplicationModels = async (body) => {
  loaderService.show();

  try {
    const { data, status } = await apiService.post(
      '/repuestos/modelos_aplicacion/',
      body,
    );
    if (status === 200) {
      return data;
    }
    return false;
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const topTen = async (body) => {
  loaderService.show();
  try {
    const { data, status } = await apiService.post('/repuestos/top_10/', body);
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const getMaterialsInfo = async (body) => {
  loaderService.show()
  try {
    const {data, status} = await apiService.get(`repuestos/planeacion_proyeccion/?materiales=${body}`)
    if (status === 200) {
      return data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const sparePartsService = {
  graphOnProyection,
  graphApplicationModels,
  getFiltersParts,
  graphOnDemand,
  topTen,
  getMaterialsInfo
};

export default sparePartsService;
